import "./App.css";
import NoteState from "./context/notes/NoteState";
import Home from "./component/Home";
import Login from "./component/Login";
import { Routes, Route } from "react-router-dom";
import Register from "./component/Register";
import Adminhome from "./admincomponent/Adminhome";
import Testhistory from "./admincomponent/Testhistory";
import Readquestion from "./admincomponent/Readquestion";
import Createtest from "./admincomponent/Createtest";
import Createrendomtest from "./admincomponent/Createrendomtest";
import JoinTest from "./clientcomponent/Jointest";
import Clienthome from "./clientcomponent/Clienthome";
import Exam from "./clientcomponent/Exam";
import Reading from "./clientcomponent/Reading";
import Selftest from "./clientcomponent/Selftest";
import Clienttesthistory from "./clientcomponent/Clienttesthistory";
import TestReview from "./clientcomponent/TestReview";
import Setftestexammodule from "./clientcomponent/Setftestexammodule";
import Readingallquestion from "./clientcomponent/Readingallquestion";
import PrivateRoute from "./routes/PrivateRoute";
import CreateQuestionPaper from "./admincomponent/CreateQuestionPaper";
import PaymentSuccess from "./admincomponent/PaymentSuccess";
import AboutEasyITI from "./clientcomponent/AboutEasyITI";
import AboutUs from "./AboutUs";
import Privacy_Policy from "./PrivacyPlocy";
import AboutEasyITIAdmin from "./admincomponent/AboutEasyITI";

import PrivacyPolicy from "./clientcomponent/PrivacyPolicy";
import PrivacyPolicyAdmin from "./admincomponent/PrivacyPolicy";
function App() {
  return (
    <>
      <NoteState>
        <Routes>
          {/* Admin side */}
          <Route path="/" element={<Login />} />
          <Route
            path="/home"
            element={
              <PrivateRoute role="INSTRUCTOR">
                <Home />
              </PrivateRoute>
            }
          />
          <Route path="/register" element={<Register />} />
          <Route
            path="/adminhome"
            element={
              <PrivateRoute role="INSTRUCTOR">
                <Adminhome />
              </PrivateRoute>
            }
          />
          <Route
            path="/testhistory"
            element={
              <PrivateRoute role="INSTRUCTOR">
                <Testhistory />
              </PrivateRoute>
            }
          />
          <Route
            path="/readquestion"
            element={
              <PrivateRoute role="INSTRUCTOR">
                <Readquestion />
              </PrivateRoute>
            }
          />
          <Route
            path="/createtest"
            element={
              <PrivateRoute role="INSTRUCTOR">
                <Createtest />
              </PrivateRoute>
            }
          />
          <Route
            path="/createrendomtest"
            element={
              <PrivateRoute role="INSTRUCTOR">
                <Createrendomtest />
              </PrivateRoute>
            }
          />
          <Route
            path="/createquestionpaper"
            element={
              <PrivateRoute role="INSTRUCTOR">
                <CreateQuestionPaper />
              </PrivateRoute>
            }
          />
          <Route
            path="/payment-success"
            element={
              <PrivateRoute role="INSTRUCTOR">
                <PaymentSuccess />
              </PrivateRoute>
            }
          />
          {/* client side */}
          <Route
            path="/jointest"
            element={
              <PrivateRoute role="STUDENT">
                <JoinTest />{" "}
              </PrivateRoute>
            }
          />
          <Route
            path="/clienthome"
            element={
              <PrivateRoute role="STUDENT">
                <Clienthome />
              </PrivateRoute>
            }
          />
          <Route
            path="/exam"
            element={
              <PrivateRoute role="STUDENT">
                <Exam />
              </PrivateRoute>
            }
          />
          <Route
            path="/reading"
            element={
              <PrivateRoute role="STUDENT">
                <Reading />
              </PrivateRoute>
            }
          />
          <Route
            path="/selftest"
            element={
              <PrivateRoute role="STUDENT">
                <Selftest />
              </PrivateRoute>
            }
          />
          <Route
            path="/clienttesthistory"
            element={
              <PrivateRoute role="STUDENT">
                <Clienttesthistory />
              </PrivateRoute>
            }
          />
          <Route
            path="/test-review"
            element={
              <PrivateRoute role="STUDENT">
                <TestReview />
              </PrivateRoute>
            }
          />
          <Route
            path="/selftestexam"
            element={
              <PrivateRoute role="STUDENT">
                <Setftestexammodule />
              </PrivateRoute>
            }
          />
          <Route
            path="/readingquestions"
            element={
              <PrivateRoute role="STUDENT">
                <Readingallquestion />
              </PrivateRoute>
            }
          />
          <Route path="/about" element={<AboutEasyITI />} />          
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/aboutEasyiti" element={<AboutEasyITIAdmin />} />
          <Route path="/privacy-policy-admin" element={<PrivacyPolicyAdmin />} />
          <Route path="/aboutUs" element={<AboutUs />} />
          <Route path="/privacypolicy" element={<Privacy_Policy />} />
        </Routes>
      </NoteState>
    </>
  );
}

export default App;
